import store from 'app/store/store';
import { ACADEMIC_SESSION_STATUS, COURSE_TYPES } from './constants/course';
import { isTeacher } from './user';

export function isCourseEditable(course) {
  return course?.course_template_type === COURSE_TYPES.TEMPLATE_2 || course?.type === COURSE_TYPES.TEMPLATE_2 || course?.type === COURSE_TYPES.NO_REFERENCED;
}

export function getIsCourseReferenced(course) {
  return course?.type === COURSE_TYPES.REFERENCED;
}

export function getIsCourseTemplate1(course) {
  return course?.type === COURSE_TYPES.TEMPLATE_1;
}

export function getGuidCourseByTemplate(course) {
  return course && getIsCourseReferenced(course) ? course.guid : null;
}

export function getTeacherAvatar(item, course) {
  if (course.users && course.users.length > 0) {
    let teacher = course.users.filter((user) => item?.created_by === user.person_guid);
    if (teacher && teacher.length > 0) return teacher[0].avatar;
  }
}

export function getTeacherName(item, course) {
  if (course.users && course.users.length > 0) {
    let teacher = course.users.filter((user) => item?.created_by === user.person_guid);
    if (teacher && teacher.length > 0) return teacher[0].name + ' ' + teacher[0].lastname;
  }
}

export function getCourseGuid(course) {
  return course.course_template_type === COURSE_TYPES.TEMPLATE_2 ? course.course_template_guid : course.guid;
}

export function isEditorialCourse(course) {
  return course.type === COURSE_TYPES.TEMPLATE_1 || course.course_template_type === COURSE_TYPES.TEMPLATE_1;
}

export function getCustomizedBy(course, currentUser) {
  // school_admins puede llegar con una forma que no es array (TANGERINE-FRONTOFFICE-4QY): la saga de
  // users.duck guarda el body entero de la respuesta, y lo ya persistido vuelve igual al rehidratar.
  // Se comprueba aquí porque esta línea corre antes de cualquier rama y afecta a todos los call sites.
  const storedSchoolAdmins = store.getState()?.users?.school_admins;
  const schoolAdmins = Array.isArray(storedSchoolAdmins) ? storedSchoolAdmins.map((admin) => admin.guid) : [];

  if (!course?.users && !currentUser?.guid) return null;
  const users = course?.users;
  if (!users || users.length === 0) return [currentUser.guid];
  return getTeachersGuid(course).concat(schoolAdmins);
}

export function getTeachersGuid(course) {
  return course?.users?.filter((user) => isTeacher(user)).map((teacher) => teacher.person_guid);
}

export function getGuidCourseProgram(course) {
  if (course.type === COURSE_TYPES.TEMPLATE_1) return course.guid;
  if (course.type === COURSE_TYPES.TEMPLATE_2 || course.type === COURSE_TYPES.NO_REFERENCED) return course.course_template_guid;
  if (course.type === COURSE_TYPES.REFERENCED) return course.program_guid;
}

export function isCourseReadOnly(course) {
  return course?.academic_session?.status === ACADEMIC_SESSION_STATUS.PAST;
}

export function isSchoolProgram(course) {
  return course?.is_school_program === true;
}

export function getShowLastNameFirst(course) {
  return Boolean(course?.studentGradebook?.config?.show_last_name_first);
}

export function getOrderBy(course) {
  return course?.studentGradebook?.config?.order_by || 'name';
}
